import { LOCIZE_NAMESPACE } from 'main/common'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../../i18n'

import { View } from './types'
import { ButtonContainer, ButtonText, Container, ListButton, MapButton } from './ViewControl.styles'

const PRE = `${i18nKeyPrefix}-SPLIT-MAP-VIEW`

interface IProps {
  setView: React.Dispatch<React.SetStateAction<View>>
  currentView: View
}

export default function ViewControl(props: IProps) {
  const { currentView, setView } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const isActive = (view: View) => {
    return currentView === view
  }

  return (
    <Container>
      <ButtonContainer>
        <ListButton active={isActive(View.Listing)} onClick={() => setView(View.Listing)}>
          <ButtonText active={isActive(View.Listing)}>{t(`${PRE}-LIST`)}</ButtonText>
        </ListButton>
        <MapButton active={isActive(View.Map)} onClick={() => setView(View.Map)}>
          <ButtonText active={isActive(View.Map)}>{t(`${PRE}-MAP`)}</ButtonText>
        </MapButton>
      </ButtonContainer>
    </Container>
  )
}
